import { render, staticRenderFns } from "./AlbumTracksPanel.vue?vue&type=template&id=2cd4482e&"
import script from "./AlbumTracksPanel.vue?vue&type=script&lang=js&"
export * from "./AlbumTracksPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports